import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((parseInt(_vm.numb)),function(index){return _c('div',{key:index,class:_vm.margin},[(_vm.show)?_c(VSkeletonLoader,{attrs:{"tile":"","elevation":"4","type":"list-item-three-line"}}):_vm._e()],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }